import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, NgForm } from '@angular/forms';
import { PropertySalesInputModel, BrokerSelecttionModel, PropertyDocument } from '../../shared/models/SavePropertyInputModel';
import { ValidationService } from '../../shared/providers/validation.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { CommonService } from '../../shared/providers/common.service';
import { ToastService } from '../../shared/providers/toast.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { timeoutWith } from 'rxjs/operators';
import { IBrokerageList } from '../../shared/models/BrokerageListOutputModel';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { BrokerageManagerService } from '../../shared/providers/brokerage-manager.service';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { ILookUp } from '../../shared/models/LookUpOutputModel';
import { Router } from '@angular/router';
import { IGuarantorList } from '../../shared/models/SavePropertyInputModel';
import { IGuarantorRating } from '../../shared/models/GuarantorModels';
import { RatingAgency } from '../../shared/enum/enum';
import { IFileUpload } from '../../shared/models/fileupload';
import { PropertyHistoryRentTermComponent } from '../../property/property-comps/property-history-rent-term/property-history-rent-term.component';
import { IPropertyRentTermModel } from '../../shared/models/PropertyRentTermModel';

interface ICharacteristics {
  id: number;
  name: string;
}

@Component({
  selector: 'app-sold-details',
  templateUrl: './sold-details.component.html',
  styleUrls: ['./sold-details.component.css']
})

export class SoldDetailsComponent implements OnInit {
  @Output() save = new EventEmitter();
  @Output() close = new EventEmitter();
  @ViewChild('salesDetailsForm') salesDetails: NgForm;
  @Input() currentSalesDetails: PropertySalesInputModel;
  @Input() modalRef: BsModalRef;

  currentData = {} as PropertySalesInputModel;
  currentDataKeep = {} as PropertySalesInputModel;
  isSaleDataExist: boolean = false;
  isValidDate: boolean = true;
  isValidCaprate: boolean = true;
  brokerageList: IBrokerageList[];
  loggedUserDetails: any;
  sprRatingList: ILookUp[];
  moodysRatingList: ILookUp[];
  fitchRatingList: ILookUp[];
  leaseStructureList: ILookUp[];
  ratingAgency = RatingAgency;
  showDiscount = true;
  //defaultCharacteristicsText: IMultiSelectTexts = {
  //    checked: 'item selected',
  //    checkedPlural: 'items selected',
  //    defaultTitle: 'Select',
  //    searchEmptyResult: 'No results found...',
  //};
  defaulCharacteristicsSettings = {
    singleSelection: false,
    text: "Select",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  };

  @Input() property: any;
  FileUpload = {} as IFileUpload;
  selectedFiles: string[] = [];
  clearFiles: number = 0;
  dcmt = {} as PropertyDocument;
  removedDocIds: number[] = [];
  @ViewChild('saleHistoryDoc') saleHistoryDoc: ElementRef;
  fileExtensionType: string = "document";
  fileUploadType: string = "multiple";
  documents: PropertyDocument[] = [];
  doc = {} as PropertyDocument;
  salesCharacteristics: ICharacteristics[];
  isEventValid: boolean = true;
  leaseEventList: ILookUp[];
  rentTerm = {} as IPropertyRentTermModel;
  firstRentTerm: IPropertyRentTermModel;
  @ViewChild(PropertyHistoryRentTermComponent) child: PropertyHistoryRentTermComponent;
  propertyHistoryRentTerms = [] as IPropertyRentTermModel[];

  constructor(public validationService: ValidationService, private authService: AuthenticationService, private _propertyManagementService: PropertyManagementService,
    private _brokerageManagerService: BrokerageManagerService, private loader: LoaderService, private toastService: ToastService, private router: Router, private _userManagerService: UserManagerService, private _commonService: CommonService) { }

  financing = 2851;
  pageLoad = false;
  isDataSaved = false;
  @Input() IsFromAddEditPage: boolean;
  ngOnInit() {
    this.loader.display(true);
    this.currentData.Id = this.currentSalesDetails.Id;
    this.currentData.PropertyId = this.currentSalesDetails.PropertyId;
    this.currentData.SaleDate = this.currentSalesDetails.SaleDate;
    this.currentData.SalePrice = this.currentSalesDetails.SalePrice;
    this.currentData.SaleCapRate = this.currentSalesDetails.SaleCapRate;
    this.currentData.SalePSF = this.currentSalesDetails.SalePSF;
    this.currentData.BrokerageId = this.currentSalesDetails.BrokerageId;
    this.currentData.AutoPopulated = this.currentSalesDetails.AutoPopulated;
    this.currentData.AutoCalcPSF = this.currentSalesDetails.AutoCalcPSF;
    this.currentData.AutoCalcCapRate = this.currentSalesDetails.AutoCalcCapRate;
    this.currentData.NOI = this.currentSalesDetails.NOI;
    this.currentData.BuildingSize = this.currentSalesDetails.BuildingSize;
    this.currentData.DateOnMarket = this.currentSalesDetails.DateOnMarket;
    this.currentData.YearOnMarket = this.currentSalesDetails.YearOnMarket;
    this.currentData.MonthOnMarket = this.currentSalesDetails.MonthOnMarket;
    this.currentData.DayOnMarket = this.currentSalesDetails.DayOnMarket;
    this.currentData.AskingPrice = this.currentSalesDetails.AskingPrice;
    this.currentData.AskingCapRate = this.currentSalesDetails.AskingCapRate;
    this.currentData.DiscountToAsking = this.currentSalesDetails.DiscountToAsking;
    this.currentData.BuyerName = this.currentSalesDetails.BuyerName;
    this.currentData.BuyerBrokerageName = this.currentSalesDetails.BuyerBrokerageName;
    this.currentData.BuyerBrokerName = this.currentSalesDetails.BuyerBrokerName;
    this.currentData.SellerName = this.currentSalesDetails.SellerName;
    this.currentData.SellerBrokerageName = this.currentSalesDetails.SellerBrokerageName;
    this.currentData.SellerBrokerName = this.currentSalesDetails.SellerBrokerName;
    this.currentData.RemainingTermYear = this.currentSalesDetails.RemainingTermYear;
    this.currentData.RemainingTermMonth = this.currentSalesDetails.RemainingTermMonth;
    this.currentData.RemainingTermDay = this.currentSalesDetails.RemainingTermDay;
    this.currentData.Is1031ExchangeBuyer = this.currentSalesDetails.Is1031ExchangeBuyer;
    this.currentData.SaleCharacteristicsId = [];
    if (this.currentSalesDetails.SaleCharacteristicsId) {
      this.currentSalesDetails.SaleCharacteristicsId.forEach(item => {
        this.currentData.SaleCharacteristicsId.push(item);
      });
    }
    this.currentData.LTV = this.currentSalesDetails.LTV;
    this.currentData.InterestRate = this.currentSalesDetails.InterestRate;
    this.currentData.Amortization = this.currentSalesDetails.Amortization;
    this.currentData.Term = this.currentSalesDetails.Term;
    this.currentData.SalesNotes = this.currentSalesDetails.SalesNotes;
    this.currentData.AutoCalcDiscount = this.currentSalesDetails.AutoCalcDiscount;
    this.currentData.GuarantorId = this.currentSalesDetails.GuarantorId;
    this.currentData.SPRatingId = this.currentSalesDetails.SPRatingId;
    this.currentData.MoodyRatingId = this.currentSalesDetails.MoodyRatingId;
    this.currentData.FitchRatingId = this.currentSalesDetails.FitchRatingId;
    this.currentData.LeaseStructureId = this.currentSalesDetails.LeaseStructureId;
    this.currentData.RentEscalationPercentage = this.currentSalesDetails.RentEscalationPercentage;
    this.currentData.RentEscalationPeriod = this.currentSalesDetails.RentEscalationPeriod;
    this.currentData.OptionNumber = this.currentSalesDetails.OptionNumber;
    this.currentData.OptionLength = this.currentSalesDetails.OptionLength;
    this.currentData.SalesNOI = this.currentSalesDetails.SalesNOI;
    this.currentData.BuyerBrokerageId = this.currentSalesDetails.BuyerBrokerageId;

    this.currentData.Documents = this.currentSalesDetails.Documents;
    this.currentData.Event = this.currentSalesDetails.Event;
    this.currentData.EventId = this.currentSalesDetails.EventId;
    this.currentData.SaleCharacteristics = this.currentSalesDetails.SaleCharacteristics;

    this.currentData.GuarantorName = this.currentSalesDetails.GuarantorName;
    this.currentData.SPRating = this.currentSalesDetails.SPRating;
    this.currentData.MoodyRating = this.currentSalesDetails.MoodyRating;
    this.currentData.FitchRating = this.currentSalesDetails.FitchRating;
    this.currentData.LeaseStructureName = this.currentSalesDetails.LeaseStructureName;
    this.currentData.Event = this.currentSalesDetails.Event;
    this.currentData.EventId = this.currentSalesDetails.EventId;
    this.currentData.SelectedFiles = this.currentSalesDetails.SelectedFiles;
    this.currentData.SaleHistoryRentTerm = this.currentSalesDetails.SaleHistoryRentTerm;
    this.propertyHistoryRentTerms = Object.assign([], this.currentSalesDetails.SaleHistoryRentTerm);

    if (this.currentData.Documents && this.currentData.Documents.length > 0) {
      this.currentData.Documents.forEach(item => {
        this.doc = {} as PropertyDocument;
        this.doc.Id = item.Id;
        this.doc.Name = item.Name;
        this.doc.Url = item.Url;
        this.documents.push(this.doc)
      });
    }

    this.pageLoad = true;
    if (!this.currentSalesDetails.IsAdd) {
      this.isSaleDataExist = true;
      if (!this.validationService.IsinValid(this.currentSalesDetails.SaleDate)) {
        this.isDataSaved = true;
      }
    }

    this.showDiscount = true;
    if (this.isSaleDataExist && this.currentData.AutoCalcDiscount) {
      if (!this.validationService.IsinValid(this.currentData.AskingPrice) && !this.validationService.IsinValid(this.currentData.SalePrice)) {
        let discount = Number(this.currentData.AskingPrice) - Number(this.currentData.SalePrice);
        let discountToAsking = ((discount * 100) / Number(this.currentData.AskingPrice));

        if (discountToAsking < 0) {
          this.showDiscount = false;
        }
        else {
          this.showDiscount = true;
        }
      }
    }

    this.currentData.SaleCapRate = this.validationService.commaFormat(this.currentData.SaleCapRate);
    this.currentData.SalePrice = this.validationService.commaFormat(this.currentData.SalePrice);
    this.currentData.SalePSF = this.validationService.commaFormat(this.currentData.SalePSF);
    this.currentData.BrokerageId = this.currentData.BrokerageId;
    this.currentData.BuyerBrokerageId = this.currentData.BuyerBrokerageId;
    this.currentData.AutoCalcCapRate = this.currentData.SaleCapRate > 0 ? this.currentData.AutoCalcCapRate : true;
    this.currentData.AutoCalcPSF = this.currentData.SaleCapRate > 0 ? this.currentData.AutoCalcPSF : true;
    //this.currentData.DateOnMarket = this.currentData.DateOnMarket ? this.validationService.convertUTCDateToLocalDate(this.currentData.DateOnMarket) : null;
    this.currentData.DateOnMarket = this.currentData.DateOnMarket ? this.currentData.DateOnMarket : null;

    if (!this.isSaleDataExist) {
      // Auto populating data from property details page
      this.bindRemainingTerm();
      //this.currentData.AskingPrice = this.property.Price;
      //this.currentData.AskingCapRate = this.property.CapRate;
      this.currentData.SalesNOI = this.property.NOI;
      this.currentData.AutoCalcDiscount = true;
      this.currentData.GuarantorId = this.property.GuarantorId;
      this.currentData.SPRatingId = this.property.SPRatingId;
      this.currentData.MoodyRatingId = this.property.MoodyRatingId;
      this.currentData.FitchRatingId = this.property.FitchRatingId;
      this.currentData.LeaseStructureId = this.property.LeaseStructureId;
      this.currentData.RentEscalationPercentage = this.property.RentEscalationPercentage == 0 ? null : this.property.RentEscalationPercentage;
      this.currentData.RentEscalationPeriod = this.property.RentEscalationPeriod;
      this.currentData.OptionNumber = this.property.OptionNumber;
      this.currentData.OptionLength = this.property.OptionLength;
      this.currentData.BrokerageId = this.property.BrokerageId ? this.property.BrokerageId : null;
    }

    this.currentData.AskingPrice = this.validationService.commaFormat(this.currentData.AskingPrice);
    //this.bindBrokerage();

    this.bindSalesCharacteristics();
    this.bindCreditRating();
    this.bindGuarantor(this.property.TenantId);
    this.onSaleCharacteristicsChange(this.currentData.SaleCharacteristicsId);
    this.loggedUserDetails = this.authService.user;

    if (this.authService.Admin() || this.authService.SuperAdmin()) {
      this._brokerageManagerService.getBrokerageList().subscribe(response => {
        this.brokerageList = response.map(o => { return { Id: o.Id, BrokerageName: o.BrokerageName }; });
      })
    }
    else {
      this._userManagerService.getBrokerages(this.loggedUserDetails.Id).subscribe(response => {
        this.brokerageList = response.map(o => { return { Id: o.Id, BrokerageName: o.BrokerageName }; });
      });
    }

    this._commonService.getLookupsByTypeId(11).subscribe(response => {
      let data = response.map(o => {
        return {
          id: o.Id, description: o.Description
        };
      });
      this.currentData.EventId = 601;// sale
      this.leaseEventList = data.filter(item => item.id == 601 ? item : null);
    });
  }

  guarantorList: IGuarantorList[];
  bindGuarantor(tenantId) {
    this._commonService.GetGuarantorMappedToTenantList(tenantId).subscribe(res => {
      this.guarantorList = res.map(o => {
        return {
          Id: o.GuarantorId, Name: o.GuarantorName
        };
      });
    });
  }

  bindCreditRating() {
    this._propertyManagementService.getSAndPRatingList().subscribe(response => {
      this.sprRatingList = response.map(o => {
        return { id: o.Id, description: o.Description };
      });
    });

    this._propertyManagementService.getMoodysRatingList().subscribe(response => {
      this.moodysRatingList = response.map(o => {
        return { id: o.Id, description: o.Description };
      });
    });

    this._propertyManagementService.getFitchRatingList().subscribe(response => {
      this.fitchRatingList = response.map(o => {
        return { id: o.Id, description: o.Description };
      });
    });

    // Loads the lease structure list
    this._commonService.getLookupsByTypeId(12).subscribe(response => {
      this.leaseStructureList = response.map(o => {
        return {
          id: o.Id, description: o.Description
        };
      });
    });
  }

  bindSalesCharacteristics() {
    this._commonService.getLookupsByTypeId(37).subscribe(response => {
      this.salesCharacteristics = response.map(o => {
        this.pageLoad = false;
        this.loader.display(false);
        return {
          id: o.Id, name: o.Description
        };
      });
    });
  }
  isSubmit = false;
  saveSalesDetails() {
    this.isSubmit = true;

    if (!this.child.validateUnsavedDate()) {
      this.toastService.addToast({ title: 'Error Occurred', msg: 'Please Save Rent Schedule', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else if (this.validateFeilds()) {
      if (this.validateDecimals()) {
        this.currentData.SaleDate = this.currentData.SaleDate;
        this.currentData.DateOnMarket = this.currentData.DateOnMarket;
        this.currentData.RemovedDocuments = this.removedDocIds;
        this.modalRef.hide();
        ////this.currentData.Documents =  this.documents;
        this.save.emit(this.currentData);
      }
    }
  }

  validateFeilds() {
    let valid = true;
    if (this.validationService.IsinValid(this.currentData.SaleDate) || this.validationService.IsinValid(this.currentData.SalePrice) || this.validationService.IsinValid(this.currentData.SaleCapRate)
      || (this.validationService.IsinValid(this.currentData.RemainingTermYear) &&
        this.validationService.IsinValid(this.currentData.RemainingTermMonth) && this.validationService.IsinValid(this.currentData.RemainingTermDay))) {
      valid = false;
    }

    if (!this.validationService.IsDate(this.currentData.SaleDate)) {
      valid = false;
    }

    if (!this.validateEvent()) {
      valid = false;
    }

    return valid;
  }

  validateDecimals() {
    var isDate = this.validationService.IsDate(this.currentData.SaleDate);
    if (isDate == false && this.currentData.SaleDate != null) {
      this.toastService.addToast({ title: 'Error Occurred', msg: 'Invalid Sale Date', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      return false;
    }

    if (this.currentData.DateOnMarket != null && !this.validationService.IsDate(this.currentData.DateOnMarket)) {
      this.toastService.addToast({ title: 'Error Occurred', msg: 'Invalid Date on market', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      return false;
    }
    if (!this.isValidCaprate) {
      return false;
    }
    //if (this.currentData.SaleCapRate == null) {
    //    this.currentData.SaleCapRate = 0;
    //}
    //if (this.currentData.SalePrice == null) {
    //    this.currentData.SalePrice = 0;
    //}
    //if (this.currentData.SalePSF == null) {
    //    this.currentData.SalePSF = 0;
    //}
    this.currentData.SaleCapRate = this.validationService.DecimalOnly(this.currentData.SaleCapRate);
    this.currentData.SalePrice = this.validationService.DecimalOnly(this.currentData.SalePrice);
    this.currentData.AskingPrice = this.validationService.DecimalOnly(this.currentData.AskingPrice);
    this.currentData.SalePSF = this.validationService.DecimalOnly(this.currentData.SalePSF);
    return true;
  }
  validateDate() {
    var isDate = this.validationService.IsDate(this.currentData.SaleDate);
    if (isDate == false && this.currentData.SaleDate != null) {
      this.isValidDate = false;
    }
    else {
      this.isValidDate = true;
    }
  }
  validatePercentage() {
    if (this.currentData.SaleCapRate > 100 || this.currentData.SaleCapRate < 0) {
      this.isValidCaprate = false;
    }
    else {
      this.isValidCaprate = true;
    }
  }
  onClose($event) {
    if (this.checkUnsavedData()) {
      if (confirm('You have unsaved data on Sale Details. Close Sale Details ?')) {
        this.propertyHistoryRentTerms.forEach(item => item.IsEditModeOn = false);
        this.modalRef.hide();
        this.close.emit();
      }
    }
    else {
      this.propertyHistoryRentTerms.forEach(item => item.IsEditModeOn = false);
      this.modalRef.hide();
      this.close.emit();
    }
  }
  checkUnsavedData() {
    try {

      if (
        (this.validationService.formatDatetoMMDDYYYY(this.currentData.SaleDate) != this.validationService.formatDatetoMMDDYYYY(this.currentSalesDetails.SaleDate)) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.SalePrice, 0) != this.validationService.IsNullOrEmptyThen(this.currentSalesDetails.SalePrice, 0)) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.SaleCapRate, 0) != this.validationService.IsNullOrEmptyThen(this.currentSalesDetails.SaleCapRate, 0)) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.SalePSF, 0) != this.validationService.IsNullOrEmptyThen(this.currentSalesDetails.SalePSF, 0)) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.BrokerageId, 0) != this.validationService.IsNullOrEmptyThen(this.currentSalesDetails.BrokerageId, 0)) ||

        (this.currentData.BuyerName != this.currentSalesDetails.BuyerName) ||
        (this.currentData.BuyerBrokerageName != this.currentSalesDetails.BuyerBrokerageName) ||
        (this.currentData.BuyerBrokerName != this.currentSalesDetails.BuyerBrokerName) ||
        (this.currentData.SellerName != this.currentSalesDetails.SellerName) ||
        (this.currentData.SellerBrokerageName != this.currentSalesDetails.SellerBrokerageName) ||
        (this.currentData.SellerBrokerName != this.currentSalesDetails.SellerBrokerName) ||

        (this.currentData.AutoPopulated != this.currentSalesDetails.AutoPopulated) ||
        (this.currentData.AutoCalcPSF != (this.isDataSaved ? this.currentSalesDetails.AutoCalcPSF : true)) ||
        (this.currentData.AutoCalcCapRate != (this.isDataSaved ? this.currentSalesDetails.AutoCalcCapRate : true)) ||

        (this.validationService.IsNullOrEmptyThen(this.currentData.NOI, 0) != this.validationService.IsNullOrEmptyThen(this.currentSalesDetails.NOI, 0)) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.BuildingSize, 0) != this.validationService.IsNullOrEmptyThen(this.currentSalesDetails.BuildingSize, 0)) ||
        (this.validationService.formatDatetoMMDDYYYY(this.currentData.DateOnMarket) != this.validationService.formatDatetoMMDDYYYY(this.currentSalesDetails.DateOnMarket)) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.YearOnMarket, 0) != this.validationService.IsNullOrEmptyThen(this.currentSalesDetails.YearOnMarket, 0)) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.MonthOnMarket, 0) != this.validationService.IsNullOrEmptyThen(this.currentSalesDetails.MonthOnMarket, 0)) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.DayOnMarket, 0) != this.validationService.IsNullOrEmptyThen(this.currentSalesDetails.DayOnMarket, 0)) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.AskingPrice, 0) != this.validationService.IsNullOrEmptyThen(this.isDataSaved ? this.currentSalesDetails.AskingPrice : this.property.Price, 0)) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.AskingCapRate, 0) != this.validationService.IsNullOrEmptyThen(this.isDataSaved ? this.currentSalesDetails.AskingCapRate : this.property.CapRate, 0)) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.DiscountToAsking, 0) != this.validationService.IsNullOrEmptyThen(this.currentSalesDetails.DiscountToAsking, 0)) ||

        (this.validationService.IsNullOrEmptyThen(this.currentData.RemainingTermYear, 0) != (this.validationService.IsNullOrEmptyThen((this.isDataSaved ? this.currentSalesDetails.RemainingTermYear : this._remainingTermYear), 0))) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.RemainingTermMonth, 0) != (this.validationService.IsNullOrEmptyThen((this.isDataSaved ? this.currentSalesDetails.RemainingTermMonth : this._remainingTermMonth), 0))) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.RemainingTermDay, 0) != (this.validationService.IsNullOrEmptyThen((this.isDataSaved ? this.currentSalesDetails.RemainingTermDay : this._remainingTermDay), 0))) ||
        (this.currentData.LTV != this.currentSalesDetails.LTV) ||
        (this.currentData.InterestRate != this.currentSalesDetails.InterestRate) ||
        (this.currentData.Amortization != this.currentSalesDetails.Amortization) ||
        (this.currentData.Term != this.currentSalesDetails.Term) ||
        (this.currentData.SalesNotes != this.currentSalesDetails.SalesNotes) ||

        (this.currentData.AutoCalcDiscount !== (this.isDataSaved ? this.currentSalesDetails.AutoCalcDiscount : true)) ||
        (this.currentData.GuarantorId !== (this.isDataSaved ? this.currentSalesDetails.GuarantorId : this.property.GuarantorId)) ||
        (this.currentData.SPRatingId != (this.isDataSaved ? this.currentSalesDetails.SPRatingId : this.property.SPRatingId)) ||
        (this.currentData.MoodyRatingId != (this.isDataSaved ? this.currentSalesDetails.MoodyRatingId : this.property.MoodyRatingId)) ||
        (this.currentData.FitchRatingId != (this.isDataSaved ? this.currentSalesDetails.FitchRatingId : this.property.FitchRatingId)) ||

        (this.currentData.LeaseStructureId != (this.isDataSaved ? this.currentSalesDetails.LeaseStructureId : this.property.LeaseStructureId)) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.RentEscalationPercentage, 0) != (this.validationService.IsNullOrEmptyThen((this.isDataSaved ? this.currentSalesDetails.RentEscalationPercentage : this.property.RentEscalationPercentage), 0))) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.RentEscalationPeriod, 0) != (this.validationService.IsNullOrEmptyThen((this.isDataSaved ? this.currentSalesDetails.RentEscalationPeriod : this.property.RentEscalationPeriod), 0))) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.OptionNumber, 0) != (this.validationService.IsNullOrEmptyThen((this.isDataSaved ? this.currentSalesDetails.OptionNumber : this.property.OptionNumber), 0))) ||
        (this.validationService.IsNullOrEmptyThen(this.currentData.OptionLength, 0) != (this.validationService.IsNullOrEmptyThen((this.isDataSaved ? this.currentSalesDetails.OptionLength : this.property.OptionLength), 0))) ||
        (this.currentData.SalesNOI != (this.isDataSaved ? this.currentSalesDetails.SalesNOI : this.property.NOI)) ||

        (JSON.stringify(this.validationService.IsNullOrEmptyThen(this.currentData.SaleCharacteristicsId, [])) != JSON.stringify(this.validationService.IsNullOrEmptyThen(this.currentSalesDetails.SaleCharacteristicsId, []))) ||

        (this.currentData.BuyerBrokerageId != this.currentSalesDetails.BuyerBrokerageId) &&
        (this.child.validateUnsavedDate())
      ) {
        return true;
      }
      else {
        return false;
      }

    }
    catch
    {
      return false;
    }
  }
  reCalcSalesRates(type: number, isChecked: boolean) {
    switch (type) {
      case 1:
        if (isChecked) {
          this.currentData.SaleCapRate = this.currentData.SalePrice > 0 ? parseFloat(((this.currentData.NOI / this.currentData.SalePrice) * 100).toFixed(2)) : null;
        }
        break;
      case 2:

        if (isChecked) {
          this.currentData.SalePSF = this.currentData.BuildingSize > 0 ? parseFloat((this.currentData.SalePrice / this.currentData.BuildingSize).toFixed(2)) : null;
        }
        break;
      case 3:
        if (this.currentData.AutoCalcCapRate) {
          this.currentData.SaleCapRate = this.currentData.SalePrice > 0 ? parseFloat(((this.currentData.NOI / this.currentData.SalePrice) * 100).toFixed(2)) : null;
        }
        if (this.currentData.AutoCalcPSF) {
          this.currentData.SalePSF = this.currentData.BuildingSize > 0 ? parseFloat((this.currentData.SalePrice / this.currentData.BuildingSize).toFixed(2)) : null;
        }
        break;
    }
    //this.getDiscountToAsking();
  }

  showSaleCharacteristics = false;
  onSaleCharacteristicsChange(event) {
    this.showSaleCharacteristics = false;
    if (this.currentData.SaleCharacteristicsId && this.currentData.SaleCharacteristicsId.indexOf(this.financing) > -1) {
      this.showSaleCharacteristics = true;
    }
    else {
      this.currentData.LTV = null;
      this.currentData.InterestRate = null;
      this.currentData.Amortization = null;
      this.currentData.Term = null;
    }

    var selectedvalues = [];
    if (event != null && event.length > 0 && this.salesCharacteristics != undefined) {
      this.salesCharacteristics.filter(x => event.includes(x.id)).forEach(item => {
        selectedvalues.push(item.name);
      });

      this.currentData.SaleCharacteristics = selectedvalues.join(',');
    }
    else {
      this.currentData.SaleCharacteristics = '';
    }
  }

  getTimeOnMarkeEvent(event) {
    if (!this.pageLoad) {
      this.currentData.DateOnMarket = event;
      this.getTimeOnMarket(null);
    }
  }

  getTimeOnMarket(event) {

    if ((!this.pageLoad) && this.validationService.IsDate(this.currentData.SaleDate) && (this.validationService.IsDate(this.currentData.DateOnMarket))) {
      let ymd = this.validationService.ExcatYearMonthDaysBetweenDates(this.currentData.SaleDate, this.currentData.DateOnMarket);
      if (ymd) {
        let ymdSplit = ymd.split('|');
        if (ymdSplit[0] && ymdSplit[0] != "0") {
          this.currentData.YearOnMarket = Number(ymdSplit[0]);
        }
        else {
          this.currentData.YearOnMarket = null;
        }
        if (ymdSplit[1] && ymdSplit[1] != "0") {
          this.currentData.MonthOnMarket = Number(ymdSplit[1]);
        }
        else {
          this.currentData.MonthOnMarket = null;
        }
        if (ymdSplit[2] && ymdSplit[2] != "0") {
          this.currentData.DayOnMarket = Number(ymdSplit[2]);
        }
        else {
          this.currentData.DayOnMarket = null;
        }
      }
    }
  }

  _remainingTermYear = 0;
  _remainingTermMonth = 0;
  _remainingTermDay = 0;
  bindRemainingTerm() {
    let datenow = new Date().setHours(0, 0, 0, 0);
    let ymd = this.validationService.YearMonthDaysBetweenDates(this.property.LeaseExpiration, new Date(datenow));
    if (ymd) {
      let ymdSplit = ymd.split('|');
      if (ymdSplit[0] && ymdSplit[0] != "0") {
        this.currentData.RemainingTermYear = Number(ymdSplit[0]);
      }
      else {
        this.currentData.RemainingTermYear = null;
      }
      if (ymdSplit[1] && ymdSplit[1] != "0") {
        this.currentData.RemainingTermMonth = Number(ymdSplit[1]);
      }
      else {
        this.currentData.RemainingTermMonth = null;
      }
      if (ymdSplit[2] && ymdSplit[2] != "0") {
        this.currentData.RemainingTermDay = Number(ymdSplit[2]);
      }
      else {
        this.currentData.RemainingTermDay = null;
      }
      this._remainingTermYear = this.currentData.RemainingTermYear;
      this._remainingTermMonth = this.currentData.RemainingTermMonth;
      this._remainingTermDay = this.currentData.RemainingTermDay;
    }
  }

  getDiscountToAsking(AutoCalcDiscount: boolean, type: number) {
    if (AutoCalcDiscount) {
      this.showDiscount = true;
      if (!this.validationService.IsinValid(this.currentData.AskingPrice) && !this.validationService.IsinValid(this.currentData.SalePrice)) {
        let discount = Number(this.currentData.AskingPrice) - Number(this.currentData.SalePrice);
        this.currentData.DiscountToAsking = ((discount * 100) / Number(this.currentData.AskingPrice));
        if (this.currentData.DiscountToAsking < 0) {
          this.currentData.DiscountToAsking = null;
          this.showDiscount = false;
        }
        else {
          this.showDiscount = true;
        }
      }
      else {
        this.currentData.DiscountToAsking = null;
      }
    }
    else {
      this.showDiscount = true;
      if (type == 2) {
        this.currentData.AutoCalcDiscount = false;
      }
    }
  }

  onGuarantorChanges() {
    if (this.currentData.GuarantorId) {
      this._commonService.GetGuarantorDetails(this.currentData.GuarantorId).subscribe(res => {
        let rating: IGuarantorRating[] = [] = res["GuarantorRating"];
        this.resetRatingModels();
        rating.forEach(item => {
          if (item.RatingAgengyType == this.ratingAgency.SandPRating) {
            this.currentData.SPRatingId = item.RatingId;
          }
          else if (item.RatingAgengyType == this.ratingAgency.MoodysRating) {
            this.currentData.MoodyRatingId = item.RatingId;
          }
          else if (item.RatingAgengyType == this.ratingAgency.FitchRating) {
            this.currentData.FitchRatingId = item.RatingId;
          }
        });
      });
    }
    else {
      this.resetRatingModels();
    }
  }
  resetRatingModels() {
    this.currentData.SPRatingId = null;
    this.currentData.MoodyRatingId = null;
    this.currentData.FitchRatingId = null;
  }


  selectedFilesListEmitter(selectedFilesListEmitter) {
    let files = Object.assign([], selectedFilesListEmitter) as any;
    const that = this;
    if (this.currentData.SelectedFiles && this.currentData.SelectedFiles.length > 0 && this.IsFromAddEditPage) {
      files.forEach(item => {
        if (that.currentData.SelectedFiles.findIndex(z => z == item) == -1) {
          that.currentData.SelectedFiles.push(item);
        }
      });
    }
    else {
      this.currentData.SelectedFiles = files;
    }
    if (this.IsFromAddEditPage) {
      files.forEach(item => {
        if (that.currentData.Documents.findIndex(z => z.File == item) == -1) {
          this.dcmt = {} as PropertyDocument;
          this.dcmt.Id = 0;
          this.dcmt.Name = item.name;
          this.dcmt.Url = '';
          this.dcmt.File = item;
          this.currentData.Documents.push(this.dcmt);
        }
      })
    }
  }

  onRemoveDocument(i: number) {

    const removed = this.documents[i];
    this.removedDocIds.push(removed.Id);
    this.toastService.addToast({
      title: 'Success',
      msg: 'Document deleted!',
      timeout: 5000,
      theme: 'bootstrap',
      position: 'bottom-right',
      type: 'success'
    });

    this.documents.splice(i, 1);
    if (this.IsFromAddEditPage) {
      let item = this.currentData.Documents[i].File as any;
      this.currentData.SelectedFiles.splice(1, this.currentData.SelectedFiles.findIndex(x => x == item));
      this.currentData.Documents.splice(i, 1);

    }
  }

  validateEvent() {
    this.isEventValid = true;
    if (this.validationService.IsinValid(this.currentData.EventId)) {

      this.isEventValid = false;
    }
    else {
      this.isEventValid = true;
    }

    return this.isEventValid;

  }

  onEventChange(event) {
    if (event != null && event > 0 && this.leaseEventList != undefined) {
      this.currentData.Event = this.leaseEventList.filter(x => x.id === event)[0].description;
    }
    else {
      this.currentData.Event = '';
      this.isEventValid = false;
    }
  }

  setPropertyNames(event, type) {
    switch (type) {
      case 1: // Guarantor
        if (event != null && event > 0 && this.guarantorList && this.guarantorList.filter(x => event == x.Id)[0] != undefined) {
          this.currentData.GuarantorName = this.guarantorList.filter(x => event == x.Id)[0].Name;
        }
        else {
          this.currentData.GuarantorName = '';
        }
        break;
      case 2: // SPRatingId
        if (event != null && event > 0 && this.sprRatingList && this.sprRatingList.filter(x => event == x.id)[0] != undefined) {
          this.currentData.SPRating = this.sprRatingList.filter(x => event == x.id)[0].description;
        }
        else {
          this.currentData.SPRating = '';
        }
        break;
      case 3: // MoodyRating
        if (event != null && event > 0 && this.sprRatingList && this.sprRatingList.filter(x => event == x.id)[0] != undefined) {
          this.currentData.MoodyRating = this.moodysRatingList.filter(x => event == x.id)[0].description;
        }
        else {
          this.currentData.MoodyRating = '';
        }
        break;
      case 4: // FitchRating
        if (event != null && event > 0 && this.sprRatingList && this.sprRatingList.filter(x => event == x.id)[0] != undefined) {
          this.currentData.FitchRating = this.fitchRatingList.filter(x => event == x.id)[0].description;
        }
        else {
          this.currentData.FitchRating = '';
        }
        break;
    }

  }

  saveHistoryRentTerm(event) {
    this.currentData.SaleHistoryRentTerm = event;
  }

  addRentTerm() {
    this.child.addRentTerm();
  }

  addRentTermOption() {
    this.child.addRentTermOption();
  }
}
